import { render, staticRenderFns } from "./fitness-declaration-partial-view.vue?vue&type=template&id=21aca9ce&"
import script from "./fitness-declaration-partial-view.vue?vue&type=script&lang=js&"
export * from "./fitness-declaration-partial-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports